import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';

import { AnalyticsService } from './analytics.service';

export const Ng1AnalyticsModule = angular
  .module('control-room.angular.analytics-service', [])
  .factory('crAnalyticsService', downgradeInjectable(AnalyticsService));
